import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div style={styles.container}>
            <h1 style={styles.heading}>404</h1>
            <h2 style={styles.subheading}>Oops! Page not found</h2>
            <p style={styles.text}>
                The page you’re looking for doesn’t exist or has been moved.
            </p>
            <Link to="/" style={styles.button}>
                Go Home
            </Link>
        </div>
    );
}

const styles = {
    container: {
        textAlign: "center",
        padding: "40px",
        background: "linear-gradient(135deg, #89f7fe 0%, #66a6ff 100%)",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        color: "#fff",
        fontFamily: "Arial, sans-serif",
    },
    heading: {
        fontSize: "120px",
        margin: "0",
        animation: "pulse 2s infinite",
    },
    subheading: {
        fontSize: "28px",
        margin: "10px 0",
    },
    text: {
        fontSize: "16px",
        maxWidth: "400px",
        margin: "10px auto 30px",
    },
    button: {
        textDecoration: "none",
        padding: "12px 25px",
        backgroundColor: "#fff",
        color: "#333",
        borderRadius: "25px",
        fontWeight: "bold",
        transition: "all 0.3s ease",
    },
};
